import React, { useEffect, useState, useRef } from "react";
import CloseIcon from '@mui/icons-material/Close';
import "./AppointmentSearchPage.css";
import AppointmentSelectSlotPage from "./AppointmentSelectSlotPage.js";
import ContactVerification from "./ContactVerification.js";
import Avatar from '@mui/material/Avatar';
import { useApp } from './../../AppProvider';
import api from "./../../axiosInstance.js"
import logger from "../../utils/logger";

function AppointmentSearchPage({ setIsModalOpenSearchAppointment }) {
  const { stringToColor, stringAvatar } = useApp();
  const [searchPatientsData, setSearchPatientsData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isContactVerificationOpen, setIsContactVerificationOpen] = useState(false);
  const [isAppointmentSelectDatePopupOpen, setIsAppointmentSelectDatePopupOpen] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState();
  const popupRef = useRef(null);

  const fetchSearchPatientsAPI = async (searchQuery) => {
    const apiUrl = `${process.env.REACT_APP_BASE_URL}/search/patients/?searchQuery=${searchQuery}`;
    try {
      const response = await api.get('/search/patients', {
              params: { searchQuery: searchQuery } 
            });

      const data = response.data
      setSearchPatientsData(data);
      logger.debug("setSearchAppointmentsData-data", data);
    } catch (error) {
      logger.error("Error fetching search patients data:", error);
    }
  };

  const openContactVerification = () => {
    setIsContactVerificationOpen(true);
  };

  // useEffect(() => {
  //   fetchSearchPatientsAPI(searchQuery);
  // }, [searchQuery]);

  // const handleSearchChange = async (event) => {
  //   const searchQuery = event.target.value;
  //   setSearchPatientsData([]);
  //   setSearchQuery(searchQuery);
  // };
  const handleSearchChange = (event) => {
      setSearchQuery(event.target.value);
      logger.debug(searchQuery)
      setSearchPatientsData([]);
      if (searchQuery.length >= 3) {
        fetchSearchPatientsAPI(searchQuery);
      }
    };
  const handleSelectPatient = async (patient) => {
    setSearchPatientsData([]);
    setSearchQuery(patient.name.firstName + " " + patient.name.middleName + " " + patient.name.lastName);
    await setSelectedPatient(patient);
    setIsAppointmentSelectDatePopupOpen(true);
  };

  return (
    <div className="appointment-search_overlay_page">
      <div className="appointment_Calendar" ref={popupRef}>
        <div className="cross-icon_container_search-patient" onClick={() => setIsModalOpenSearchAppointment(false)}>
          <CloseIcon />
        </div>
        <h2>Search Patient</h2>
        <p className="para-uhid">Enter Patient's UHID or Patient Name & Mobile Number</p>
        <input
          className="uhid-search_input"
          type="search"
          id="gsearch"
          name="gsearch"
          placeholder="Search UHID/Patient Name/Mobile Number"
          value={searchQuery}
          onChange={handleSearchChange}
        />
        <div className="appointment_patient__container">
          {searchPatientsData.map((item, index) => (
            <div key={index} className="search-card-appointment_patient" onClick={() => handleSelectPatient(item)}>
              <Avatar sx={{width: { md: 40, lg: 50, xl: 50 }, height: { md: 40, lg: 50, xl: 50 }, bgcolor: item.img ? 'transparent' : stringToColor(item.name.firstName) }}
                alt={item.name.firstName}
                src={item.img} >
                {!item.img && stringAvatar(`${item.name.firstName}`).children}
              </Avatar>
              <div className="appointment-patient-info">
                <p className="nameHeading-patient">{`${item.name.firstName || ''} ${item.name.middleName || ''} ${item.name.lastName || ''}`}</p>
                {(item.contact?.phoneNumber?.phoneNumber || item.phoneNumber) && (
                  <p className="appointment-patient-phone">{item.contact?.phoneNumber?.phoneNumber || item.phoneNumber}</p>
                )}
              </div>
            </div>
          ))}
        </div>
        <button className="search-button-patient" onClick={openContactVerification}>
          Add Patient
        </button>

        {isContactVerificationOpen && <ContactVerification setIsContactVerificationOpen={setIsContactVerificationOpen} />}

        {isAppointmentSelectDatePopupOpen && (
          <AppointmentSelectSlotPage
            patient={selectedPatient}
            onClose={setIsModalOpenSearchAppointment}
            setIsAppointmentSelectDatePopupOpen={setIsAppointmentSelectDatePopupOpen}
          />
        )}
      </div>
    </div>
  );
}

export default AppointmentSearchPage;
